import script from "./SensorView.vue?vue&type=script&setup=true&lang=js"
export * from "./SensorView.vue?vue&type=script&setup=true&lang=js"

import "./SensorView.vue?vue&type=style&index=0&id=4924c7d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4924c7d5"]])

export default __exports__